// src/components/songEdit/components/composer/SearchDropdown.tsx
import React from 'react';
import { SearchResult } from '../types/composerTypes';

interface SearchDropdownProps {
  results: SearchResult[];
  isLoading: boolean;
  onSelect: (result: SearchResult) => void;
  show: boolean;
}

export const SearchDropdown: React.FC<SearchDropdownProps> = ({
  results,
  isLoading,
  onSelect,
  show
}) => {
  if (!show) return null;

  return (
    <div className="position-absolute w-100 mt-1 shadow-sm bg-white border rounded z-10">
      {isLoading ? (
        <div className="p-3 text-center">Loading...</div>
      ) : results.length > 0 ? (
        <ul className="list-unstyled mb-0">
          {results.map((result) => (
            <li
              key={result.composer_id}
              className="p-2 cursor-pointer hover:bg-light"
              onClick={() => onSelect(result)}
            >
              <div>{result.full_name}</div>
              {result.era && (
                <small className="text-muted">{result.era}</small>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-3 text-center">No results found</div>
      )}
    </div>
  );
};
